window.ENAC = true   // attenzione !!!!
window.GREEN = false  // attenzione !!!!
window.ECFOP = !window.ENAC && !window.GREEN

if(window.GREEN) window.ENAC = false

window.VERSION = "V.1.1.65"

import { DateTime } from "luxon";

window.MODULIJOIN = window.ENAC

let getUserLIV = false
let getUserID = false

// parametri sicuri: funzionano solo in DEBUG
// getUserID = 2549 // RAVANELLI
// window.loctime = DateTime.local(2025,4,8,11,54,32,0)
// getUserLIV = 7

document.title = window.ENAC ? "ENAC" : (window.GREEN ? "Fondazione Green" : "E.C.Fo.P.")
//document.querySelector("link[rel='shortcut icon']").href = window.ENAC ? "img/faviconenac.ico" : "img/favicon.png";
document.querySelector("link[rel*='icon']").href = window.ENAC ? "img/faviconenac.ico" : (window.GREEN ? "img/favicongreen.png" : "img/favicon.png");

console.log(window.VERSION)

window.DEBUG = true && (process.env.NODE_ENV == 'development');

// ATTENZIONE: sono anche in router.js perché viene caricato prima
window.secret = "ropels3cr3t"
window.keyname = "jwt5"

import './registerServiceWorker'

// tabella host per versione swone
var produrl = ''
var tblh = {
  "localhost": (window.ENAC ? "swoneenac2" : "swone2"),
  "swone": "swone2",
  "ecfoptest.homeip.net": "swone2.homeip.net",
  "fadecfop.homeip.net": "swone2.homeip.net",
  "swone.ecfop.it": "swone2.ecfop.it",
  "swoneenac": "swoneenac2",
  "enactest.homeip.net": "enac2.homeip.net",
  "enac.homeip.net": "enac2.homeip.net",
  "swone.cfpcanossa.it": "webapp.cfpcanossa.it",
  "swone.fondazionegreen.it": "webapp.fondazionegreen.it",
}
var url = new URL(window.location.href);
if(url.searchParams.get("app")){
  if(tblh[window.location.hostname])
    produrl = `${window.location.protocol}//${tblh[window.location.hostname]}`
}
window.baseurl = (process.env.NODE_ENV == 'development' ? 'http://swone2' : produrl)
console.log("DBG:",window.location.hostname,produrl,window.baseurl)


import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css"
Vue.component('multiselect', Multiselect)


import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
Vue.component('datetime', Datetime);

// importo globalmente !
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

import VueLuxon from "vue-luxon";
Vue.use(VueLuxon);

import Lightbox from 'vue-pure-lightbox'
Vue.use(Lightbox)


var loctime = url.searchParams.get("loctime");
if(loctime){
  window.loctime_par = DateTime.fromISO(loctime)
  console.log("DBG: loctime",window.loctime_par)
}


// import FullCalendar from 'vue-full-calendar'
// Vue.use(FullCalendar)
//import 'fullcalendar/dist/fullcalendar.css'
//import 'fullcalendar/dist/fullcalendar.print.css'
import { API } from "@/api.js";
import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT, {})
var jwt = require('jsonwebtoken')

axios.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem(window.keyname);
    if (token) {
      config.headers['Authorization'] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// todo
// cssVars()

Vue.use(BootstrapVue)

// li gestisco così, per non iniettarli inutilmente in tutti i controlli
window.myMixin = {
  created: function () {
    this.hello()
  },
  computed: {
    ENAC(){
      return window.ENAC
    },
    ECFOP(){
		return window.ECFOP
	},
	GREEN(){
		return window.GREEN
	},
},
  methods: {
    hello: function () {
      // console.log('hello from mixin!')
    },
    getTokenData(){
      var token = sessionStorage.getItem(window.keyname)
      //console.log("TOKEN:",token)
      var data = false
      try {
        data = this.$jwt.decode(token, window.secret)  
      } catch (error) {
        console.error("getTokenData",error)
        sessionStorage.setItem(window.keyname,null)
        this.$router.push("/");
      }
      // console.log("DATA!!!",data)
      return data
    },
    getCorsID() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.guest.corsistaid
      else
        return 0
    },
    getBackdoor() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.bd
      else
        return false
    },
    getTest() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.test
      else
        return false
    },
    getAlunnoID() {
      var data = this.getTokenData()
      console.log("TOK1:", data)
      if (data && data.sub && data.sub.guest)
        return data.sub.guest.alunnoid
      else
        return 0
    },
    getSchema() {
      var data = this.getTokenData()
      // console.log("TOK2:", data)
      if (data && data.sub)
        return data.sub.schema
      else
        return "public"
    },
    getUserID() {
    if(window.DEBUG && getUserID) return getUserID
      var data = this.getTokenData()
      // console.log("TOK3:", data)
      if (data && data.sub && data.sub.user)
        return data.sub.user.docenteid
      else if (data && data.sub && data.sub.guest)
        return data.sub.guest.corsistaid
      else
        return "USERID"
    },
    getUser() {
      var data = this.getTokenData()
      // console.log("TOK3:", data)
      if (data && data.sub && data.sub.user)
        return data.sub.user
      else if (data && data.sub && data.sub.guest)
        return data.sub.guest
      else
        return "USERID"
    },
    getUserLIV() {

		if(window.DEBUG && getUserLIV!==false) return getUserLIV

  	var data = this.getTokenData()
      // console.log("TOK4:", data)
      if (data && data.sub && data.sub.user)
        return data.sub.user.livello
      else
        return "USERLIV"
    },
    getUserName() {
      var data = this.getTokenData()
      if (data && data.sub && data.sub.user)
        return data.sub.user.nome
      else if (data && data.sub && data.sub.guest)
        return data.sub.guest.nome + " " + data.sub.guest.cognome
      else
        return "USERNAME"
    },
  }
}

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App, Vue
  }
})

// se ho il token faccio qui la richiesta
let token = sessionStorage.getItem(window.keyname);
if (token){
  try {
    if(jwt.verify(token, window.secret)) {

      API.getpars(vue)

      // axios.get(window.baseurl + "/getpars").then( ps => {
      //   console.log("GETPARS:",ps.data.dati)
      //   ps.data.dati.map( p => {
      //     window[p.nome] = p.valore
      //     console.log(p.nome + " = " + p.valore)
      //   })
      // })
    } else {
      sessionStorage.getItem(window.keyname,null)
      token = null
    }
  } catch(e){
    sessionStorage.getItem(window.keyname,null)
    token = null
  }
}
